import { parties } from './PartyTag'
import PartyTag from "./PartyTag";


const Filters = ({ activeParty, onSelectParty }) => {
    const onPartyClick = (party) => {
        const newParty = activeParty === party ? '' : party
        onSelectParty(newParty);
    }
    return (<>
        <ul className="shadow mt-2 flex flex-row flex-wrap gap-x-1.5 md:gap-y-2 gap-y-1 p-2.5 pt-3 rounded ">
            {parties.map((party) => (
                <li key={party}>
                    <button onClick={() => onPartyClick(party)} className={`px-1.5 text-sm text-gray-600 pt-1.5 items-center rounded-lg border ${activeParty === party ? "border-neutral-300 shadow" : "border-transparent hover:shadow"}`}>
                        <PartyTag party={party} size={15} />
                    </button>
                </li>
            ))}
        </ul>
    </>)
}

export default Filters;